<template>
  <person-detail :view-mode="'edit'" />
</template>

<script>
import PersonDetail from "./components/detail";

export default {
  name: "StaffingEdit",
  components: { PersonDetail }
};
</script>